module.exports = {
      id: "audio-play-usage",
      viewBox: "0 0 384 512",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#audio-play",
      toString: function () {
        return this.url;
      }
    }